import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Caption, TopNavLink } from '../FontStyles';
import baseTheme from '../../themes/baseTheme';
import { Link } from 'react-router-dom';
import { Popover, Position, Pane, Menu } from 'evergreen-ui';

const SubheaderCont = Styled(Flex)`
border-bottom: ${baseTheme.border};
height: 60px;
width: 100%;
background-color: ${baseTheme.colors.white};
position: fixed;
align-items: center;
justify-content: space-between
top: 60px;
z-index: 1;
left: 0;
display: ${props => (props.navShown ? 'flex' : 'none')};

& .avatar-arrow{
  font-size: 20px;
}
img {
  max-height: 50px;
}

i {
  font-size: 32px;
  color: ${baseTheme.colors.primaryFont};
}


`;

const MenuItemCont = Styled(Flex)`
width: 80px;
margin:8px;
border-radius: 8px;
text-align: center;
height: 32px;
justify-content: center;
align-items: center;
&
&:hover {
  cursor: pointer;
  background-color:${baseTheme.colors.lightGrey};
}

`;

class Subnav extends React.Component {
  render() {
    console.log('navShown');
    console.log(this.props.navShown);
    const currentPatient = this.props.data[this.props.data.length - 1];
    console.log('currentPatient');
    console.log(currentPatient);
    return (
      <SubheaderCont navShown={this.props.navShown}>
        <Flex width={1}>
          <Flex width={0.33} px={4} alignItems="center" justifyContent="flex-start">
            {/*window.location.pathname !== '/' && (
              <Caption>
                Patient: {`${currentPatient.allSettings.firstName} ${currentPatient.allSettings.lastName}`}
              </Caption>
            )*/}
          </Flex>

          <Flex width={0.33} justifyContent="center">
            <MenuItemCont>
              <TopNavLink to="/patients/012/basics">
                <Caption> Basics </Caption>
              </TopNavLink>
            </MenuItemCont>
            <MenuItemCont>
              <TopNavLink to="/patients/012/daily">
                <Caption> Daily </Caption>
              </TopNavLink>
            </MenuItemCont>

            <MenuItemCont>
              <TopNavLink to="/">
                <Caption> Trends </Caption>
              </TopNavLink>
            </MenuItemCont>

            <MenuItemCont>
              <TopNavLink to="/">
                <Caption> BG Log </Caption>
              </TopNavLink>
            </MenuItemCont>
            <MenuItemCont>
              <TopNavLink to="/settings">
                <Caption> Settings </Caption>
              </TopNavLink>
            </MenuItemCont>
          </Flex>
        </Flex>
      </SubheaderCont>
    );
  }
}
export default Subnav;
